import { Button } from 'antd';
import styled from 'styled-components';

type WrapperProps = {
  paddingLeft?: number;
};

export const Wrapper = styled.div<WrapperProps>`
  padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : 12)}px;
  position: relative;
  margin: 8px 0px;
  display: flex;
  width: fit-content;
  img,
  .ant-image-mask {
    border-radius: 4px;
  }
`;

export const StyledButton = styled(Button)`
  position: absolute;
  top: 0px;
  right: 0px;
  cursor: pointer;
`;
